module.exports = __webpack_public_path__ + "2df0f435151d47778e4bc04e71fa19a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/podzimni-detsky-tabor-5.jpg
// module id = 1200
// module chunks = 0